import { combineReducers } from 'redux-immutable';

import theme from './theme.duck';

export default combineReducers({
  theme
});
